import React, { useState, useEffect } from "react";
import Select from "react-select";
import CompanyEl from "../Components/company-form/CompanyEl";
import styled from "styled-components";
import TypeEl from "../Components/company-form/TypeEl";
import PeriodEl from "../Components/company-form/PeriodEl";
import { useForm, Controller } from "react-hook-form";
import ReviewFormEl from "../Components/company-form/ReviewFormEl";
import { registerLocale } from "react-datepicker";
import axios from "axios";
import { engApi } from "../api/engApi";
import { config } from "process";
import { getCompany, getInternshipRequest,getInternshipRequestBySt_id } from "../api/crud";
import CardEl from "../Elements/CardEl";

const CompanyForm = () => {
  const hooksForm = useForm();
  const { handleSubmit, register, watch, setValue } = hooksForm;
  const [isReview, setIsReview] = useState(false);
  const [internType, setInternType] = useState(null);
  const [optionsCompany, setOptionsCompany] = useState([]);
  const [internshipRequestOwn, setInternshipRequestOwn] = useState([]);
  const getUsername = localStorage.getItem("username");
  // const getUsername = 55050419;

  const watchCompany = watch("company");
  const watchName = watch("name");
  const watchInternType = watch("intern-type");

  // const onHandleSubmit = (ev) => {
  //   console.log({ ev });

  //   let formData = new FormData();
  //   formData.append("req_id", 2022080802);
  //   formData.append("st_id", 55050444);
  //   formData.append("cp_id", +ev.company.value);
  //   formData.append("co_name", ev.firstName);
  //   formData.append("co_pos", "test");
  //   formData.append("cp_tel", "123");
  //   formData.append("co_email", "test@test.com");
  //   formData.append("type_internship", 2);
  //   formData.append("date_create", new Date());
  //   formData.append("start_date", new Date());
  //   formData.append("end_date", new Date());
  //   formData.append("status", "1");
  //   formData.append("comment", "1");

  //   engApi.post("/internship-request/", formData, {
  //     Headers: {
  //       "Content-Type": "multipart/form-data",
  //     },
  //   });
  // };

  const onHandleReview = (ev) => {
    console.log({ ev });
    setIsReview(true);
  };
  const onHandleBack = () => {
    setIsReview(false);
  };

  const geetInternRequest = () => {
    getInternshipRequestBySt_id(getUsername)
      .then((res) => {
        const filterOwn = res.filter((el) => el.st_id == getUsername) ?? [];
        // setInternshipRequestOwn(filterOwn ?? []);

        const newReqId = `${getUsername}${(filterOwn.length + 1)
          .toString()
          .padStart(2, "0")}`;

        setValue("req_id", newReqId);

      })
      .catch((err) => {
        console.log(err);
      });




  };

  const getCompanyList = async () => {
    getCompany()
      .then((res) => {
        const list = res.map((company) => {
          return {
            label: company.name,
            value: company.id,
            data: company,
          };
        });

        setOptionsCompany(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getCompanyList();
    geetInternRequest();
  }, []);

  const displayForm = (
    <div>
      <h1 className="h3 mb-3">ยื่นความประสงค์ขอฝึกงานและสหกิจศึกษาปีการศึกษา {new Date().getFullYear() + 543}</h1>
      <div className="row">
        <div className="col-12 ">
          <CompanyEl
            hooksForm={hooksForm}
            Controller={Controller}
            optionsCompany={optionsCompany}
          />
          <TypeEl
            hooksForm={hooksForm}
            Controller={Controller}
            setInternType={setInternType}
            internType={internType}
          />
         
        </div>
      </div>
      <div>
        <button
          disabled={watchCompany && watchName && watchInternType ? false : true}
          className="btn btn-primary  btn-pill mx-2"
          onClick={handleSubmit(onHandleReview)}
        >
          ตรวจสอบ
        </button>
      </div>
    </div>
  );

  const displayReview = (
    <div>
      <h1 className="h3 mb-3">สรุปรายละเอียดการขอฝึกงานและสหกิจศึกษา</h1>

      <ReviewFormEl
        hooksForm={hooksForm}
        internType={internType}
        optionsCompany={optionsCompany}
      />
    </div>
  );

  return (
    <div className="main">
      <main className="content">
        <div className="container-fluid p-0">
          <form action="./submit-intern-form.php" method="post">
            {/* {isReview ? displayReview : displayForm}{" "} */}
            <input type="number" className="d-none" {...register("req_id")} />
            <input
              type="number"
              className="d-none"
              {...register("st_id", {
                value: getUsername,
              })}
            />
            {displayForm}
            <br />
            {isReview ? (
              <div>
                {displayReview}
               
                <button
                  className="btn btn-primary  btn-pill  mx-2"
                  type="submit"
                  disabled={
                    !watch("check1") || !watch("check2") || !watch("check3")
                      ? true
                      : false
                  }
                >
                  Submit
                </button>

              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </main>
    </div>
  );
};

export default CompanyForm;
